import globalRouter from "./globalRouter";
import { logout } from "./authSlice";

const CHANNEL_NAME = "drug-sync:auth-sync";
const tabId = `${Date.now()}-${Math.random().toString(16).slice(2)}`; // NOSONAR - transient tab identifier for BroadcastChannel deduplication only

function getChannel() {
  // eslint-disable-next-line no-undef
  if (!globalThis?.window) return null;
  if (!globalThis?.BroadcastChannel) return null;
  return new BroadcastChannel(CHANNEL_NAME);
}

/**
 * Call once at app startup (src/index.js) to listen for cross-tab logout.
 * @param {Function} dispatch Redux dispatch
 */
export function setupCrossTabLogoutListener(dispatch) {
  try {
    const channel = getChannel();
    if (!channel) return;

    channel.addEventListener("message", (event) => {
      const msg = event?.data;
      if (msg?.type !== "LOGOUT") return;
      if (msg.tabId === tabId) return; // ignore own broadcast

      // Clear auth state in this tab.
      dispatch(logout());
      globalRouter.navigate("/login");
    });
  } catch {
    // best-effort only
  }
}

/**
 * Broadcast logout so other tabs can clear their session.
 */
export function broadcastLogout() {
  try {
    const channel = getChannel();
    if (!channel) return;
    channel.postMessage({ type: "LOGOUT", tabId });
    // Channel will be GC'd; no need to keep reference.
  } catch {
    // best-effort only
  }
}
